import styled from 'styled-components'

export const Wrapper = styled.div`
  padding-top: 13px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 88vh;

  .pincode-input-container {
    width: 100%;
    margin-left: -15px;
    .pincode-input-text {
      padding: 4px !important;
      margin: 0 0px;
      text-align: center;
      border: 3px solid;
      background: transparent;
      width: auto;
      height: 60px;
      font-size: 26px;
    }
    .pincode-input-text:focus {
      outline: red;
      box-shadow: none;
    }
  }
  p {
    font-size: ${({ theme }) => theme.fontSize.s};
    line-height: 24px;
    letter-spacing: 0.75px;
    color: ${({ theme }) => theme.colors.gray};
    opacity: 0.8;
    margin-top: -15px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-top: -10px;
    }
  }
  .blur {
    background-color: #6e7191;
    opacity: 1;
  }
  .top {
    margin-top: 52px;
  }
  .tops {
    margin-top: 33px;
  }
  .wallet {
    font-size: ${({ theme }) => theme.fontSize.xx2};
  }
  h4 {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.DarkCyan};
  }

  .destination,
  .amount {
    margin-top: 25px;
  }
  input {
    margin-top: -10px;
  }
  .line {
    height: 3px;
    width: auto;
    background: ${({ theme }) => theme.colors.grey};
    margin: 0px -47px;
  }
  .css-b62m3t-container {
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid #858c94;
    box-sizing: border-box;
    border-radius: 8px;
    height: 60px;
  }
  .css-1s2u09g-control {
    height: 60px;
  }
  .css-14dclt2-Input {
    font-size: 14px;
    line-height: 24px;
    color: #6e7191;
    opacity: 0.8;
    padding-left: 16px;
  }
  .css-1okebmr-indicatorSeparator {
    background-color: transparent;
  }
  .css-1hb7zxy-IndicatorsContainer {
    border-bottom: 1px solid #858c94;
  }
  .css-319lph-ValueContainer {
    height: 60px;
    border-bottom: 1px solid #858c94;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .cancel {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.CollaboBlue};
    border: 1px solid ${({ theme }) => theme.colors.CollaboBlue};
  }
  .confirm {
    margin: 2px 0px;
  }
  .note {
    margin-top: 15px;
  }
  .choose {
    font-size: ${({ theme }) => theme.fontSize.x4};
    line-height: 14px;
    color: ${({ theme }) => theme.colors.dark};
    /* margin-top:20px; */
  }
  input,
  .color {
    color: ${({ theme }) => theme.colors.CollaboBlue};
  }
  .height {
    height: 50px;
  }
`
export const FormContainer = styled.form`
  .form-group {
    position: relative;
    margin-bottom: 25px;

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    }
  }

  .form-group.has-error input {
    border: 1px solid red;
  }

  .form-group.has-error .error-icon {
    display: block;
  }

  .error-icon {
    position: absolute;
    top: 12px;
    right: 0px;
    font-size: 24px;
    display: none;
    color: red;
  }
  .pincode-input-text {
    width: 57px !important;
    border-radius: 5px !important;

    @media (max-width: 391px) and (max-width: 600px) {
      width: 45px !important;
    }
    @media (max-width: 380px) {
      width: 32px !important;
      height: 30px !important;
    }
  }

  .error-text {
    text-align: left;
    margin: 0 26px;
    padding-top: 4px;
    text-transform: capitalize;
    color: red;
    font-size: ${({ theme }) => theme.fontSize.s};
  }

  .form-group input:focus {
    border: 1px solid blue;
  }
`
